import { render, staticRenderFns } from "./add-documentation.vue?vue&type=template&id=45df2b34&scoped=true&"
import script from "./add-documentation.vue?vue&type=script&lang=js&"
export * from "./add-documentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df2b34",
  null
  
)

export default component.exports